// src/helpers/env.ts

export function getApiBaseUrl() {
  return import.meta.env.VITE_API_BASE_URL
}

export function getIS4BaseUrl() {
  return import.meta.env.VITE_IS4_BASE_URL
}

export function getAppOneSignalId() {
  return import.meta.env.VITE_APP_ONESIGNAL_ID
}

export function isEBEnv(env: 'production' | 'mock' | 'local') {
  return import.meta.env.VITE_EB_ENV === env
}

export function getBaseUrl() {
  return import.meta.env.BASE_URL
}

export function getAppDomain() {
  return import.meta.env.VITE_APP_DOMAIN
}

export function getAppBaseUrl() {
  return import.meta.env.VITE_APP_BASE_URL
}

export function getClarityProjectId() {
  return import.meta.env.VITE_CLARITY_PROJECT_ID
}

export function getCmsBaseUrl() {
  return import.meta.env.VITE_CMS_BASE_URL
}

export function getAppVersion() {
  return import.meta.env.PACKAGE_VERSION || '0.0.0'
}

export function getStripePublishableKey() {
  return import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
}

export function getStripePricingTableId() {
  return import.meta.env.VITE_STRIPE_PRICING_TABLE_ID
}

export function getStripePricingTableIdDark() {
  return import.meta.env.VITE_STRIPE_PRICING_TABLE_ID_DARK
}

export function getRevenueCatIosApiKey() {
  return import.meta.env.VITE_REVENUECAT_IOS_API_KEY
}
